import Effects from './Effects';
import Contents from './Contents';
import Camera from './Camera';
import Environment from '../common/Environment';
import Sky from '../common/Sky';
import obsidianSkyEffects from './obsidianSkyEffects.json';
import VisibilityGroup from '../common/VisibilityGroup';

export default function Obsidian() {
  return (
    <VisibilityGroup beaker="chapter3">
      <Contents />
    </VisibilityGroup>
  );
};

export const Mount = () => {
  return (
    <>
      <Environment asset="obsidian_environment" />
      <Sky
        beaker="chapter3"
        effects={ obsidianSkyEffects }
      />
      <fogExp2
        attach="fog"
        density={ 0.00013 }
        color={ [0.1, 0.4, 0.55] }
      />
    </>
  );
};

export { Camera, Effects };